import React, { useEffect, useRef } from "react";
import "./CertificationBadges.css";

const certifications = [
  {
    id: "iso",
    src: "/images/iso.png",
    alt: "ISO Certified",
    label: "ISO Certified",
    desc: "Quality Management System",
  },
  {
    id: "msme",
    src: "/images/msme.png",
    alt: "MSME Registered",
    label: "MSME Registered",
    desc: "Ministry of MSME, Govt. of India",
  },
  {
    id: "startupindia",
    src: "/images/startupindia.png",
    alt: "Startup India",
    label: "Startup India",
    desc: "DPIIT Recognised Startup",
  },
  {
    id: "aicte",
    src: "/images/aicte.png",
    alt: "AICTE Approved",
    label: "AICTE Approved",
    desc: "All India Council for Technical Education",
  },
];

const CertificationBadges = () => {
  const sectionRef = useRef(null);
  const badgeRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cert-badge--visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    const current = badgeRefs.current;
    current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="cert-section" ref={sectionRef} aria-label="Certifications and Recognitions">
      {/* Decorative blobs */}
      <div className="cert-blob cert-blob--left" aria-hidden="true"></div>
      <div className="cert-blob cert-blob--right" aria-hidden="true"></div>

      <div className="cert-inner">
        <div className="cert-heading">
          <span className="cert-eyebrow">Trusted &amp; Recognised</span>
          <h2 className="cert-title">
            Our <span className="cert-title--highlight">Certifications</span> &amp; Accreditations
          </h2>
          <p className="cert-subtitle">
            Backed by national and global bodies — proof of our commitment to quality, innovation, and compliance.
          </p>
          <div className="cert-divider" aria-hidden="true"></div>
        </div>

        <div className="cert-grid">
          {certifications.map((cert, i) => (
            <div
              key={cert.id}
              className="cert-badge"
              ref={(el) => (badgeRefs.current[i] = el)}
              style={{ "--delay": `${i * 0.12}s` }}
            >
              <div className="cert-badge__glow" aria-hidden="true"></div>
              <div className="cert-badge__img-wrap">
                <img
                  src={cert.src}
                  alt={cert.alt}
                  className="cert-badge__img"
                  loading="lazy"
                />
              </div>
              <div className="cert-badge__info">
                <span className="cert-badge__label">{cert.label}</span>
                <span className="cert-badge__desc">{cert.desc}</span>
              </div>
              <div className="cert-badge__shine" aria-hidden="true"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationBadges;
